// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'folder-search';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M6.187 14.063H1.835m13.353-7.875v-2.25a1.125 1.125 0 0 0-1.126-1.126H6.189V1.688A1.125 1.125 0 0 0 5.063.563H1.688A1.125 1.125 0 0 0 .563 1.688v11.1a1.275 1.275 0 0 0 2.502.328l1.763-6.115a1.125 1.125 0 0 1 1.081-.814h10.404A1.125 1.125 0 0 1 17.4 7.603' />
    <path d='M7.886 11.823a3.937 3.937 0 1 0 7.874 0 3.937 3.937 0 0 0-7.874 0zm9.552 5.614-2.83-2.83' />
  </g>
);

export const viewBox = '0 0 18 18';
